import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-multimedia-player',
  templateUrl: './multimedia-player.component.html',
  styleUrls: ['./multimedia-player.component.scss'],
})
export class MultimediaPlayerComponent  implements OnInit {
  @Input() mediaType: string = "";
  @Input() viewOffline: boolean = false;
  @Input() hasLocalPath: boolean = false;
  @Input() mediaUrl: string = "";
  @Input() posterUrl: string = "";

  constructor() { }

  ngOnInit() {}


  afterLoadComplete(pdf): void {
    // this.totalPages = pdf.pagesCount;
    console.log("total pages: ",pdf);
  }


  pagechanging(e, media){
    // console.log("page changing", e);
    // e === this.totalPages && media.status_progress !== "revisado"
    // if(e === this.totalPages) {
    //   console.log("pdf completed");
    //   // localStorage.setItem("pdfComplete", "true")
    // }
  }

}
